
import { computed, defineComponent, PropType } from 'vue'
import { useStore } from 'vuex'
import Button from '@/components/elements/Button.vue'
import FavoriteButton from '@/components/elements/FavoriteButton.vue'
import HospitalLabel from '@/components/elements/HospitalLabel.vue'
import HospitalTag from '@/components/elements/HospitalTag.vue'
import TableDefinition, { Definition } from '@/components/elements/TableDefinition.vue' // eslint-disable-line
import { SpecialistCassete } from '@/types/HospitalDetail'
import { ActionHistory } from '@/types/StoreState'
import { numberFormatAddComma } from '@/utils/commonMethods'

export default defineComponent({
  props: {
    data: {
      type: Object as PropType<SpecialistCassete>,
      default: () => ({})
    }
  },

  components: {
    Button,
    FavoriteButton,
    TableDefinition,
    HospitalLabel,
    HospitalTag
  },

  setup(props) {
    const store = useStore()

    // お気に入り判定
    const isFavorite = computed(() => {
      if (!store.state.isLogin) return false

      return store.state.userInfo.s_favorite_history.some(
        (el: ActionHistory) => el.s_training_id == props.data.s_training_id
      )
    })

    const labels = computed(() => {
      const res = []
      if (props.data.facility) res.push(props.data.facility)
      return props.data.program_subjects?.length
        ? [...res, ...props.data.program_subjects]
        : res
    })

    const aboutTableData = computed((): Definition[] => {
      return [
        {
          dt: '当科病床数',
          dd:
            props.data.department_bed_num !== null
              ? `${numberFormatAddComma(props.data.department_bed_num)}`
              : 0,
          unit: '床'
        },
        {
          dt: '研修医数',
          dd: props.data.resident_num ?? 0,
          unit: '人'
        },
        {
          dt: '当科指導医数',
          dd: props.data.instructor_num ?? 0,
          unit: '人'
        },
        {
          dt: '募集人数',
          dd: props.data.recruitment_num ?? 0,
          unit: '人'
        }
      ]
    })

    const aboutText = computed(() => {
      const text = props.data.overview_list || ''
      return text?.length > 77 ? text.substring(0, 76) + '…' : text
    })

    const favBtnLabel = computed(() =>
      isFavorite.value ? 'お気に入り登録済み' : 'お気に入りに保存'
    )

    const clickFavBtn = () => {
      if (isFavorite.value) {
        store.dispatch('removeFavorite', {
          id: props.data.hospital_id,
          sId: props.data.s_training_id
        })
      } else {
        store.dispatch('addFavorite', {
          id: props.data.hospital_id,
          sId: props.data.s_training_id
        })
      }
    }

    const linkUrl = computed(
      () =>
        `/search/hospital/detail/${props.data.hospital_id}?tab=latter&id=${props.data.s_training_id}`
    )

    return {
      labels,
      aboutTableData,
      aboutText,
      isFavorite,
      clickFavBtn,
      favBtnLabel,
      linkUrl
    }
  }
})
